// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__4gw-r","status":"default_status__3PW2t","info":"default_info__cQGaP","info__status":"default_info__status__Ui7Bv"};